import { createAsyncThunk } from '@reduxjs/toolkit';

import CommonApi from '../../services/api/CommonApi';

const getPaymentTypes = createAsyncThunk(
  'company-info/getPaymentTypes',
  async () => {
    const response = await CommonApi.getPaymentTypes();
    if (response.status === 200) {
      return response.data;
    }
    return undefined;
  }
);

const getPaymentTokens = createAsyncThunk(
  'company-info/getPaymentTokens',
  async () => {
    const response = await CommonApi.getPaymentTokens();
    if (response.status === 200) {
      return response.data;
    }
    return undefined;
  }
);

const getAvailablePaymentTokens = createAsyncThunk(
  'company-info/​getAvailablePaymentTokens',
  async (_, thunkAPI) => {
    const response = await CommonApi.getAvailablePaymentTokens();
    if (response.status === 200) {
      return response.data;
    }
    return undefined;
  }
);

export { getPaymentTypes, getPaymentTokens, getAvailablePaymentTokens };
